const rawStyles = {
    buttonSubmit: {},
    checkbox: {
        height: 'auto',
    },
    controlGroup: {
        padding: '5px 10px',
    },
    geoBarIntersectionCtr: {
        flexGrow: 1,
    },
    layerGroup: {
        alignItems: 'center',
        padding: '2px 5px',
    },
    layersListCtr: {
        maxHeight: '200px',
        overflowY: 'auto',
    },
    subHeaderLabel: {
        marginLeft: '10px',
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '12px',
    },
    textField: {
        flexGrow: 1,
    },
    toolLabel: {
        fontWeight: 'bold',
    },
}

export default rawStyles
